import { useEffect } from 'react';

import { getPhaseFromHash, setPhaseHash } from 'App/Helpers';

/**
 * Keeps LP wizard `phase` state in sync with the URL hash in both directions:
 * - `hashchange` → `setPhase` (via `getPhaseFromHash()`, default `1`)
 * - `phase` → `setPhaseHash` (updates `#N` / `#N?params` when a numeric phase hash exists)
 *
 * @param {number} phase - Current phase from `useState`.
 * @param {React.Dispatch<React.SetStateAction<number>>} setPhase - Phase setter from `useState`.
 */
export function useSyncedPhaseFromHash(phase, setPhase) {
    useEffect(() => {
        const handleHashChange = () => {
            const newPhase = Number(getPhaseFromHash()) || 1;

            setPhase(newPhase);
        };

        window.addEventListener('hashchange', handleHashChange);

        return () => {
            window.removeEventListener('hashchange', handleHashChange);
        };
    }, [setPhase]);

    useEffect(() => {
        setPhaseHash(String(phase));
    }, [phase]);
}
